export class PriorityBase {
    id: number;
    name: string;
    priority: number;
}
